import { useEffect, useState } from "react";

import axios from "axios";
import IsLoading from "../components/IsLoading";

export default function Balance() {
  const [ERC20Address, setERC20Address] = useState("");
  const [balances, setBalances] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ERC20Address) {
      setLoading(true);
      const timeout = setTimeout(() => {
        setLoading(false);
        alert('Address not found');
      }, 10000);
      axios(
        `https://cryptools-server-production.up.railway.app/api/balance?address=${ERC20Address}`
        // `http://localhost:4000/api/balance?address=${ERC20Address}`
        )
        .then(({ data }) => {
          setBalances(data);
          setLoading(false);
          clearTimeout(timeout);
        })
        .catch((error) => {
          setLoading(false);
          clearTimeout(timeout);
          alert('Address not found');
          setERC20Address("");
        });
    }
  }, [ERC20Address]);

  return (
    <div className="flex flex-col gap-8">
      {loading && <IsLoading />}

      <input
        type="text"
        placeholder="Ethereum Address"
        value={ERC20Address}
        onChange={(e) => setERC20Address(e.target.value)}
        className="w-1/2 py-3 px-2 pr-4 m-auto text-gray-500 border rounded-md outline-none bg-gray-50 focus:bg-white focus:border-indigo-600"
      />
      {ERC20Address && (
  <h3 className="text-2xl flex justify-center">
    <span className="font-bold">ETH Balance: </span>{" "}
    {balances.nativeBalance} ETH
  </h3>
)}
{ERC20Address && (
            <div className="w-full max-w-screen-xl mx-auto px-4 md:px-8">
<div className="shadow-sm border rounded-lg overflow-x-auto">
    <table className="w-full table-auto text-sm text-left">
        <thead className="bg-gray-50 text-gray-600 font-medium border-b">
            <tr>
                <th className="py-3 px-6">Ticker</th>
                <th className="py-3 px-6">Amount</th>
            </tr>
        </thead>
        <tbody className="text-gray-600 divide-y">
        {balances?.tokenBalances?.map((balance, index) => {
          const [amount, symbol] = balance.split(" ");
          const roundedAmount = parseFloat(amount).toFixed(2);
          return (
                    <tr key={index}>
                        <td className="px-6 py-4 whitespace-nowrap">{symbol}</td>
                        <td className="px-6 py-4 whitespace-nowrap">{roundedAmount}</td>
                    </tr>
          );
        })}
        </tbody>
    </table>
</div>
</div>
)}

    </div>
  );
}